
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.85 2.5h-7.7A1.65 1.65 0 002.5 4.15v7.7c0 .911.739 1.65 1.65 1.65h7.7c.09-.001.18-.01.27-.027l.165-.039h.065l.204-.077.072-.038c.055-.034.115-.061.17-.1.073-.054.143-.112.209-.175l.038-.05a1.48 1.48 0 00.149-.176l.05-.072a1.27 1.27 0 00.098-.192.55.55 0 00.039-.082c.027-.066.044-.138.066-.21v-.082a1.43 1.43 0 00.055-.33v-7.7a1.65 1.65 0 00-1.65-1.65zm-7.7 9.9a.55.55 0 01-.55-.55V9.48l1.81-1.816a.55.55 0 01.78 0l4.73 4.736H4.15zm8.25-.55a.55.55 0 01-.039.198.55.55 0 01-.043.077.517.517 0 01-.05.066L9.325 9.248l.485-.483a.55.55 0 01.78 0l1.81 1.814v1.271zm0-2.827L11.366 8a1.694 1.694 0 00-2.332 0l-.484.484L6.966 6.9a1.694 1.694 0 00-2.332 0L3.6 7.923V4.15a.55.55 0 01.55-.55h7.7a.55.55 0 01.55.55v4.873z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    